import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import {rtkQueryErrorLogger} from "./slices";
import {authAPI} from './slices/auth'
import {projectAPI} from './slices/project'


export const store = configureStore({
    reducer: {
        [authAPI.reducerPath]: authAPI.reducer,
        [projectAPI.reducerPath]: projectAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false}).concat(
            authAPI.middleware,
            projectAPI.middleware,
            rtkQueryErrorLogger
        )
})

setupListeners(store.dispatch)
